import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { CatalogPromotionsActions } from '../constants/catalog_promotions/catalog_promotions_actions';
import ProductModel from './models/product';

class CatalogPromotionsStoreClass extends ReduceStore {
    getInitialState() {
        return {
            loadingPromotions: false,
            promotions: [],
            buyerAssistUrl: null
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.CATALOG_PROMOTIONS_ACTION) {
            switch (action.type) {
                case CatalogPromotionsActions.SET_PROMOTIONS:
                    state.loadingPromotions = false;
                    state.promotions = action.payload.map((product) => {
                        return new ProductModel(product);
                    });

                    this.__emitChange();
                    break;

                case CatalogPromotionsActions.LOAD_CATALOG_PROMOTIONS_ACTION:
                    state.loadingPromotions = true;
                    this.__emitChange();
                    break;

                case CatalogPromotionsActions.SET_BUYER_ASSIST_URL:
                    state.buyerAssistUrl = action.payload;
                    this.__emitChange();
                    break;


            }
        }

        return state;
    }
}

const CatalogPromotionsStore = new CatalogPromotionsStoreClass(Dispatcher);
export { CatalogPromotionsStore };